import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteRiskyActivitiesInformation = new Map<string, ConfirmationData>([
    ["e183c59a-b6a9-4b53-8da9-65db1bd851c0|a1794961-3f8d-43c5-8007-6f8f1a36b4ed", { hidden: true }],
    ["0e0dd2e7-8b14-4a9d-93b1-8843e5ec4f76", { color: "skyblue",fontWeight: "bold" }],
    ["6fed0d0f-6497-4095-85cc-e5500472b372|3bfc3c6b-7901-4569-8a03-093c8d904188", { hidden: true }],
    ["c9e2bed8-0c59-4d81-8793-32aba25c3af1", { hidden: true }],
    ["6915e6c3-340f-4401-87db-1632de54a7ad", { hidden: true }],
    ["a73814f7-368f-4e23-b8fb-9369a373b67f", { hidden: true }],
    ["ad2e69a9-131c-40e0-bf92-15714d9e382b", { hidden: true }],
    ["3b8e237f-7c6c-42f9-9a76-0bbe2e8bc081", { hidden: true }],
    ["b03501b9-5d68-4f17-961a-c342cfb5f0d6|454cfcb1-d6bc-4e5b-bb19-2b85f6bae8df", { label: "Sim/Não" }],
    ["883453ea-7d6f-4692-8534-efc630890461|dbc2de67-429e-44ce-a172-0c9ac6c6a55a", { label: "Sim/Não" }],
    ["8a790490-82c1-4122-bcd0-26abda54f07e|1d1e32fa-0063-4aa6-b6fd-c546713d5328", { label: "Sim/Não" }],
    ["101fc2d1-eaec-4012-93aa-1bc2cebfc629|2e6febcd-d4d5-427a-918c-e1d728306203", { label: "Sim/Não" }],
    ["89f0b02d-bb44-4d5e-9852-2ca5e6416cf6|79a67db8-d2f5-4966-8052-7f45c3a432a9", { label: "Sim/Não" }],
    ["b044ac44-feba-4e66-a1a6-8f7563b22764", { color: "skyblue",fontWeight: "bold" }],
    ["09d85a66-3020-4484-9b2d-ca6076016d8f|ebaf4574-0e4d-4201-ae2e-e30a17c30b81", { hidden: true }],
    ["33ac97fc-5438-443e-b967-eeeea72db301|4977bb17-45d4-4619-917d-a38e2f3f856c", { hidden: true }],
    ["627aba55-b024-418d-9f86-94bfec215ceb", { hidden: true }],
    ["553cd88e-30b1-4d50-806b-24aae0b1c82c", { hidden: true }],
    ["053d49f3-9b42-4d7a-9224-7d84e1f5f8e8|6db29b56-7ad1-4606-ab99-e199735dc942", { label: "Sim/Não" }],
    ["1e2412f3-1b58-4f10-af0c-44d0ac920c9a|f6e4e261-9ae2-4d59-9f24-a7759bbb6b30", { label: "Sim/Não" }],
    ["1a5d1f91-968e-4442-a9a1-1d4ac87985d4|39badfa1-9c29-4353-ace8-347c6d33c813", { label: "Sim/Não" }],
    ["1399cdf2-0aa9-4834-b2f8-b9b09428476f", { hiddenAll: true }],
    ["0c76bfc0-42d6-4566-8b4e-ab6d8959faa1", { hiddenAll: true }],
    ["312dcdc7-e1f3-47b2-a722-eb0fae67a351", { hiddenAll: true }],
    ["fc2f7f58-818e-4b2c-9b00-74e8e196e17e", { hiddenAll: true }],
    ["f89f741e-67f3-4b57-88ec-a51f83dfd84f", { hiddenAll: true }],

]);



